module.exports = __webpack_public_path__ + "img/Frontal_op3.8cc28ebd.jpg";